// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationUpdateRequest
 */
export interface ConversationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ConversationUpdateRequest
     */
    title: string;
}

/**
 * Check if a given object implements the ConversationUpdateRequest interface.
 */
export function instanceOfConversationUpdateRequest(value: object): value is ConversationUpdateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function ConversationUpdateRequestFromJSON(json: any): ConversationUpdateRequest {
    return ConversationUpdateRequestFromJSONTyped(json, false);
}

export function ConversationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
    };
}

export function ConversationUpdateRequestToJSON(json: any): ConversationUpdateRequest {
    return ConversationUpdateRequestToJSONTyped(json, false);
}

export function ConversationUpdateRequestToJSONTyped(value?: ConversationUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
    };
}

